import { branchOutlayPaymentForm, branchOutlayHistoryForm } from './branchOutlayPayment'
import { branchConferenceForm } from './branchConference'
import { branchEventForm } from './branchEvent'
import { branchMemberPopularizeForm } from './branchMemberPopularize'
import {
  branchWorkRecordForm, branchWorkRecordDevelopedForm,
  branchWorkRecordTransferForm, branchWorkRecordSuggestForm,
  branchWorkRecordAttendForm, branchWorkRecordCompleteForm
} from './branchWorkRecord'
import { branchMemberRecordForm } from './branchMemberRecord'
import { branchSocialForm } from './branchSocial'
import { branchUnityForm } from './branchUnity'
import { branchMemberForm } from './branchMember'
import { branchSchemeForm } from './branchScheme'
import { branchPoliticsProposalForm, branchPoliticsSocialForm } from './branchPoliticsProposal'
import { branchWorkPlanForm, branchWorkSummaryForm } from './branchWorkPlan'
import { branchMemberCommitteeForm } from './branchMemberCommittee'

const gztMod = {
  label: '返回工作台',
  value: 'gzt',
}

export const getMenus = () => ({
  onlyGzt: [ gztMod ],
  sxzzjs: {
    defaultIdx: 'dyzj',
    children: [
      gztMod,
      {
        label: '党员之家',
        value: 'dyzj',
        rName: ['party-info', 'party-list', 'party-edit']
      },
      {
        label: '教育基地',
        value: 'jyjd',
        rName: 'education'
      }
    ]
  },
  zzjs: {
    defaultIdx: 'sfzb',
    children: [
      gztMod,
      {
        label: '示范支部',
        value: 'sfzb',
        rName: ['demonstrate', 'demonstrate-list']
      },
      {
        label: '榜样人物',
        value: 'byrw',
        rName: 'rolemodel'
      },
      {
        label: '示范支部回头看',
        value: 'htk',
        rName: ['lookback', 'lookback-grass-root', 'lookback-operation']
      }
    ]
  }
})

export const statusType = () => [
  {
    label: '全部',
    value: '',
  },
  {
    label: '已通过',
    value: 1,
  },
  {
    label: '已拒绝',
    value: 2,
  },
  {
    label: '未审核',
    value: 3,
  },
]

export const noticeStatus = () => [
  {
    label: '已通过',
    value: 1,
  },
  {
    label: '已拒绝',
    value: 2,
  },
  {
    label: '已发布',
    value: 3,
  },
]

export const noticeListMenu = () => [
  {
    label: '重要通知',
    index: 0,
    icon: 'important',
  },
  {
    label: '活动通知',
    index: 1,
    icon: 'activity',
  },
]

export const categoryType = () => [
  {
    label: '业主',
    value: 572,
    key: 'propertyUrl',
    name: '房产证照片',
  },
  {
    label: '共同居住人',
    value: 573,
    key: 'bookletUrl',
    name: '户口本',
  },
  {
    label: '临时居住人',
    value: 574,
    key: 'residenceCard',
    name: '居住登记卡',
  },
  {
    label: '租户',
    value: 575,
    key: 'contractUrl',
    name: '租房合同',
  },
]

export const ukeyPermissions = () => [
  {
    label: '档案管理',
    value: 'dagl',
    children: [
      {
        label: '上传文件',
        value: 'dagl-scwj',
      },
      {
        label: '下载文件',
        value: 'dagl-xxwj',
      },
    ],
  },
  {
    label: '辖区单位管理',
    value: 'xqdwgl',
    children: [
      {
        label: '单位管理(添加、删除、编辑)',
        value: 'xqdwgl-curd',
      },
    ],
  },
  {
    label: '辖区商户管理',
    value: 'xqshgl',
    children: [
      {
        label: '商户管理(添加、删除、编辑)',
        value: 'xqshgl-curd',
      },
    ],
  },
  {
    label: '居民管理',
    value: 'jmgl',
    children: [
      {
        label: '居民管理(添加、删除、编辑)',
        value: 'jmgl-curd',
      },
      {
        label: '居民审核',
        value: 'jmgl-sh',
      },
    ],
  },
  {
    label: '党员管理',
    value: 'dygl',
    children: [
      {
        label: '党员管理(删除、编辑)',
        value: 'dygl-curd',
      },
    ],
  },
  {
    label: '通知管理',
    value: 'tzgl',
    children: [
      {
        label: '发布活动通知',
        value: 'hdtz-add',
      },
      {
        label: '删除活动通知',
        value: 'hdtz-del',
      },
      {
        label: '发布重要通知',
        value: 'zytz-add',
      },
      {
        label: '删除重要通知',
        value: 'zytz-del',
      },
    ],
  },
]

export const demoType = () => [
  {
    label: '全部',
    value: '',
  },
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 2,
  },
]

export const buildType = () => [
  { label: '租借型', value: '租借型' },
  { label: '公助型', value: '公助型' },
  { label: '社会型', value: '社会型' },
  { label: '捐助型', value: '捐助型' },
  { label: '私产住宅', value: '私产住宅' },
  { label: '党员所在单位', value: '党员所在单位' },
  { label: '其他', value: '其他' },
]

export const setType = () => [
  { label: '租借型', value: '租借型' },
  { label: '公助型', value: '公助型' },
  { label: '社会型', value: '社会型' },
  { label: '捐助型', value: '捐助型' },
  { label: '私产住宅', value: '私产住宅' },
  { label: '党员所在单位', value: '党员所在单位' },
  { label: '支部党员自有', value: '支部党员自有' },
  { label: '其他', value: '其他' },
]
export const whether = () => [
  {
    label: '否',
    value: '否',
  },
  {
    label: '是',
    value: '是',
  },
]

export const serviceRange = () => [
  { label: '省级组织', value: '省级组织' },
  { label: '市级组织', value: '市级组织' },
  { label: '区级组织', value: '区级组织' },
  { label: '基层支部', value: '基层支部' },
]

export const isHave = () => [
  {
    label: '无',
    value: '无',
  },
  {
    label: '有',
    value: '有',
  },
]

export const area = () => [
  { label: '50㎡以下', value: '50㎡以下' },
  { label: '50㎡-100㎡', value: '50㎡-100㎡' },
  { label: '100㎡-200㎡', value: '100㎡-200㎡' },
  { label: '200㎡-500㎡', value: '200㎡-500㎡' },
  { label: '500㎡以上', value: '500㎡以上' },
]

export const activityNum = () => [
  { label: '0次', value: '0次' },
  { label: '1-5次', value: '1-5次' },
  { label: '5-10次', value: '5-10次' },
  { label: '10-20次', value: '10-20次' },
  { label: '20次以上', value: '20次以上' },
]



export const reviewStatus = () => [
  { label: '已通过', value: 1 },
  { label: '待审核', value: 3 },
  { label: '已拒绝', value: 2 },
]

export const branchState = () => [
  { label: '民革模范支部', value: '0' },
  { label: '全国示范支部', value: '1' },
  { label: '省级示范支部', value: '2' },
  { label: '市级示范支部', value: '3' },
  { label: '其它', value: '4' }
]

export const auditStatus = () => [
  { label: '待审核', value: 1 },
  { label: '审核通过', value: 2 },
  { label: '已拒绝', value: 3 }
]

export const lookBack = () => [
  { label: '中央', value: '1' },
  { label: '省级', value: '2' },
  { label: '市级', value: '3' },
  { label: '未开展', value: '4' },
]

export const roleModelSession = () => [
  { label: '第一届', value: 1 },
  { label: '第二届', value: 2 },
  { label: '第三届', value: 3 }
]

export const educationBase = () => [
  { label: '民革党史教育基地', value: '民革党史教育基地' },
  { label: '民革党员教育基地', value: '民革党员教育基地' }
]

export const specialTypeOptions = () => [
  { label: '前辈故居、墓园，纪念馆（亭）', value: 1 },
  { label: '孙中山、辛亥革命', value: 2 },
  { label: '抗战遗迹', value: 3 },
  { label: '党史', value: 4 },
  { label: '起义', value: 5 },
  { label: '其他', value: 6 }
]

export const setTime = () => [
  { label: '2010年', value: '2010年' },
  { label: '2011年', value: '2011年' },
  { label: '2012年', value: '2012年' },
  { label: '2013年', value: '2013年' },
  { label: '2014年', value: '2014年' },
  { label: '2015年', value: '2015年' },
  { label: '2016年', value: '2016年' },
  { label: '2017年', value: '2017年' },
  { label: '2018年', value: '2018年' },
  { label: '2019年', value: '2019年' },
  { label: '2020年', value: '2020年' },
  { label: '2021年', value: '2021年' },
  { label: '2022年', value: '2022年' },
  { label: '2023年', value: '2023年' },
  { label: '2024年', value: '2024年' },
]

// 下载模板映射
export const branchAllTemplates = {
  '1': 'branchMember',
  '7': 'branchMemberCommittee',
  '9': 'branchOutlayHistory',
  '10': 'branchOutlayPayment',
  '11': 'branchPoliticsProposal',
  '12': 'branchPoliticsSocial',
  '13': 'branchSocial',
  '14': 'branchUnity',
  '8': 'branchMemberPopularize', // 宣传工作记录表
  '2': 'branchWorkRecord', // 支部党员发展情况
  '3': 'branchWorkRecordDeveloped', // 发展新党员信息
  '4': 'branchWorkRecordSuggest', // 支部党员推荐情况
  '5': 'branchWorkRecordAttend', // 支部(党员)参加上级工作记录
  '6': 'branchWorkRecordComplete' // 支部(党员)完成上级工作记录
}

export const branchAllApis = {
  branchOutlayHistory: {
    list: 'getBranchOutlayHistory',
    add: 'addBranchOutlayHistory',
    del: 'delBranchOutlayHistory',
    upload: 'importBranchOutlayApi'
  },
  branchOutlayPayment: {
    list: 'getBranchOutlayPayment',
    add: 'addBranchOutlayPayment',
    del: 'delBranchOutlayPayment',
    upload: 'importBranchMemberPaymementApi'
  },

  branchConference: {
    list: 'getBranchConferenceList',
    add: 'addBranchConference',
    del: 'delBranchConference'
  },

  branchEvent: {
    list: 'getBranchEventList',
    add: 'addBranchEvent',
    del: 'delBranchEvent'
  },

  branchMemberPopularize: {
    list: 'getBranchMemberPopularizeList',
    add: 'addBranchMemberPopularize',
    del: 'delBranchMemberPopularize',
    upload: 'importBranchPopularizeApi'
  },

  branchWorkRecord: {
    list: 'getBranchWorkRecordList',
    add: 'addBranchWorkRecord',
    del: 'delBranchWorkRecord',
    upload: 'importBranchMemberDevelopingApi'
  },

  branchWorkRecordDeveloped: {
    list: 'getBranchRecordDevelopedList',
    add: 'addBranchRecordDeveloped',
    del: 'delBranchRecordDeveloped',
    upload: 'importBranchNewMemberApi'
  },

  branchWorkRecordTransfer: {
    list: 'getBranchRecordTransferList',
    add: 'addBranchRecordTransfer',
    del: 'delBranchRecordTransfer'
  },

  branchWorkRecordSuggest: {
    list: 'getBranchRecordSuggestList',
    add: 'addBranchRecordSuggest',
    del: 'delBranchRecordSuggest',
    upload: 'importBranchSuggestApi'
  },

  branchWorkRecordAttend: {
    list: 'getBranchRecordAttendList',
    add: 'addBranchRecordAttend',
    del: 'delBranchRecordAttend',
    upload: 'importBranchAttendApi'
  },

  branchWorkRecordComplete: {
    list: 'getBranchRecordCompleteList',
    add: 'addBranchRecordComplete',
    del: 'delBranchRecordComplete',
    upload: 'importBranchCompleteApi'
  },

  branchMemberRecord: {
    list: 'getBranchMemberRecord',
    add: 'addBranchMemberRecord',
    del: 'delBranchMemberRecord'
  },

  branchSocial: {
    list: 'getBranchSocial',
    add: 'addBranchSocial',
    del: 'delBranchSocial',
    upload: 'importBranchSocialServiceApi'
  },

  branchUnity: {
    list: 'getBranchUnity',
    add: 'addBranchUnity',
    del: 'delBranchUnity',
    upload: 'importBranchUnityApi'
  },
  branchMember: {
    list: 'getBranchMember',
    add: 'addBranchMember',
    del: 'delBranchMember',
    upload: 'importBranchMemberApi'
  },
  branchScheme: {
    list: 'getBranchScheme',
    add: 'addBranchScheme',
    del: 'delBranchScheme'
  },
  branchMemberLog: {
    list: 'getBranchMemberLog',
    del: 'delBranchMemberLog'
  },
  branchMemberCommittee: {
    list: 'getBranchMemberCommittee',
    add: 'addBranchMemberCommittee',
    del: 'delBranchMemberCommittee',
    upload: 'importBranchCommitteeApi'
  },
  branchPoliticsProposal: {
    list: 'getBranchPoliticsProposal',
    add: 'addBranchPoliticsProposal',
    del: 'delBranchPoliticsProposal',
    upload: 'importBranchProposalApi'
  },
  branchPoliticsSocial: {
    list: 'getBranchPoliticsSocial',
    add: 'addBranchPoliticsSocial',
    del: 'delBranchPoliticsSocial',
    upload: 'importBranchSocialApi'
  },
  branchWorkPlan: {
    list: 'getBranchWorkPlan',
    add: 'addBranchWorkPlan'
  },
  branchWorkSummary: {
    list: 'getBranchWorkSummary',
    add: 'addBranchWorkSummary'
  }
}

export * from './lookbackList'

export default {
  branchOutlayPaymentForm,
  branchOutlayHistoryForm,
  branchConferenceForm,
  branchEventForm,
  branchMemberPopularizeForm,
  branchWorkRecordForm,
  branchWorkRecordDevelopedForm,
  branchWorkRecordTransferForm,
  branchWorkRecordSuggestForm,
  branchWorkRecordAttendForm,
  branchWorkRecordCompleteForm,
  branchMemberRecordForm,
  branchSocialForm,
  branchUnityForm,
  branchMemberForm,
  branchSchemeForm,
  branchMemberCommitteeForm,
  branchPoliticsProposalForm,
  branchPoliticsSocialForm,
  branchWorkPlanForm,
  branchWorkSummaryForm
}